import type { IValue } from './Graph';

export type Functor<T = IValue> = (...args: Array<any>) => T | undefined;
export type AsyncFunctor<T = IValue> = (...args: Array<any>) => Promise<T | undefined>;

export interface NamedAsyncFunctor<T extends IValue = IValue> {
  name: string;
  func: AsyncFunctor<T>;
}

export const FunctorsRegistry = new Map<string, NamedAsyncFunctor<IValue>>();

export function MakeAsyncFunctor<T extends IValue = IValue>(
  functorName: string,
  functor: AsyncFunctor<T>
): NamedAsyncFunctor<T> {
  if (FunctorsRegistry.has(functorName)) {
    throw new Error('Functor [' + functorName + '] is already registered.');
  }
  const ret = {
    name: functorName,
    func: functor
  };
  FunctorsRegistry.set(functorName, ret);
  return ret;
}

export function MakeFunctor<T extends IValue = IValue>(functorName: string, functor: Functor<T>): NamedAsyncFunctor<T> {
  if (FunctorsRegistry.has(functorName)) {
    throw new Error('Functor [' + functorName + '] is already registered.');
  }
  const adapter = (...args: Array<any>): Promise<T | undefined> => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const ret = functor(...args);
    return Promise.resolve(ret);
  };
  const ret = {
    name: functorName,
    func: adapter
  };
  FunctorsRegistry.set(functorName, ret);
  return ret;
}
